<template>
  <footer>
    <span @click="handleOpenUrl(1)">游戏许可及服务协议</span> ｜
    <span @click="handleOpenUrl(2)" class="pri">游戏隐私保护指引</span>
    © 2021 Betta. All rights reserved.
    <!-- <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=备案号">京公网安备11000002000001号</a> -->
    <a
      target="_blank"
      style="margin-left:40px;"
      href="https://beian.miit.gov.cn/#/Integrated/recordQuery"
      >京ICP备12035264号</a
    >
  </footer>
</template>
<script>
export default {
  name: "SlideChild",
  methods: {
    handleOpenUrl(type) {
      type == 1
        ? window.open("https://betta-games.com/terms?lang=zh_CN")
        : window.open("https://betta-games.com/privacy?lang=zh_CN");
    }
  }
};
</script>
<style scoped lang="less">
footer {
  color: #fff;
  width: 100%;
  text-align: center;
  font-size: 14px;
  line-height: 60px;
  background: #000;
  a {
    color: #fff;
    padding: 0 5px;
    &:last-child {
      padding: 0;
    }
  }
  span {
    cursor: pointer;
  }
  .pri {
    margin-right: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/parts/homeFoot.vue